import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ProductCollections } from '../../../models/product';

@Component({
  selector: 'app-home-carousel-item1',
  imports: [MatButtonModule, MatRippleModule, RouterModule],
  templateUrl: './home-carousel-item1.html',
  styleUrl: './home-carousel-item1.scss',
})
export class HomeCarouselItem1 {
  get collectionNo(): string {
    return ProductCollections.Sweaters;
  }

  get appname(): string {
    return environment.appname;
  }
}
